import { render, staticRenderFns } from "./report-listing.component.vue?vue&type=template&id=5b5602a1"
import script from "./report-listing.component.ts?vue&type=script&lang=ts&external"
export * from "./report-listing.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports